import { useEffect, useState } from "react"

export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(window.matchMedia(query).matches)

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query)

    const handleChange = (e: MediaQueryListEvent) => setMatches(e.matches)

    mediaQueryList.addEventListener("change", handleChange)

    return () => mediaQueryList.removeEventListener("change", handleChange)
  }, [query])

  return matches
}
